import { CSVRow, loadCSVFromData } from "../../../lib/csvLoader";
import { BeautyProfilerAllureId } from "../types/BeautyProfilerAllure";
import { ProfilerProductId } from "../types/ProfilerProduct";
import { answerOptionsData } from "../../../data/answerOptions";

import { AnswerOptionId, AnswerOption } from "../types/AnswerOption";

export class AnswerRepository {
  private answerOptions: AnswerOption[] = [];
  private isInitialized = false;

  constructor() {
    this.initialize();
  }

  async initialize(): Promise<void> {
    if (this.isInitialized) {
      return;
    }

    try {
      const data = await loadCSVFromData(answerOptionsData);
      this.answerOptions = data.map((row: CSVRow) => ({
        id: parseInt(row.id) as AnswerOptionId,
        label: row.label,
        description: row.description,
        beautyProfilerAllure: row.beautyProfilerAllure
          ? (parseInt(row.beautyProfilerAllure) as BeautyProfilerAllureId)
          : undefined,
        beautyProfilerProducts: row.beautyProfilerProducts
          ? row.beautyProfilerProducts
              .split(",")
              .map((product) => parseInt(product) as ProfilerProductId)
          : undefined,
      }));

      this.isInitialized = true;
    } catch (error) {
      console.error("Failed to initialize AnswerRepository:", error);
      throw error;
    }
  }

  getAnswerById(id: AnswerOptionId): AnswerOption {
    if (!this.isInitialized) {
      throw new Error(
        "AnswerRepository not initialized. Call initialize() first."
      );
    }
    const answer = this.answerOptions.find((answer) => answer.id === id);
    if (!answer) {
      throw new Error(`Answer with id ${id} not found`);
    }
    return answer;
  }

  getAnswersByIds(ids: AnswerOptionId[]): AnswerOption[] {
    if (!this.isInitialized) {
      throw new Error(
        "AnswerRepository not initialized. Call initialize() first."
      );
    }
    return this.answerOptions.filter((answer) => ids.includes(answer.id));
  }

  getAllAnswers(): AnswerOption[] {
    if (!this.isInitialized) {
      throw new Error(
        "AnswerRepository not initialized. Call initialize() first."
      );
    }
    return [...this.answerOptions];
  }

  isReady(): boolean {
    return this.isInitialized;
  }
}

export const answerRepository = new AnswerRepository();
